"use client"

import { HomePageLayout } from "@/components/website/homepage-layout"

export default function PrivacyPolicyPage() {
  return (
    <HomePageLayout>
      <div className="container mx-auto px-4 py-6 space-y-4">
        <h1 className="text-2xl font-bold">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground">
          At Oxygen Tamil News we respect your privacy. This Privacy Policy explains what information we collect, how we use it, and the choices you have.
        </p>
        <section className="space-y-2 text-sm text-muted-foreground">
          <h2 className="text-base font-semibold text-foreground">Information we collect</h2>
          <p>
            We may collect information you provide directly (such as your name, email address or feedback) and basic technical data when you visit our site,
            like IP address, browser type and pages visited. This helps us keep the site secure and understand how readers use our content.
          </p>
        </section>
        <section className="space-y-2 text-sm text-muted-foreground">
          <h2 className="text-base font-semibold text-foreground">How we use your information</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>To provide and improve our news service and website experience.</li>
            <li>To respond to your queries, feedback or support requests.</li>
            <li>To monitor performance, prevent abuse and maintain security.</li>
          </ul>
        </section>
        <section className="space-y-2 text-sm text-muted-foreground">
          <h2 className="text-base font-semibold text-foreground">Data sharing</h2>
          <p>
            We do not sell your personal data. We may share limited information with trusted service providers who help us operate the site (for example,
            analytics or hosting), and only under confidentiality obligations and applicable law.
          </p>
        </section>
        <section className="space-y-2 text-sm text-muted-foreground">
          <h2 className="text-base font-semibold text-foreground">Your choices</h2>
          <p>
            You can contact us to request access, correction or deletion of your personal data where applicable. You may also control cookies through your
            browser settings as described in our Cookie Policy.
          </p>
        </section>
      </div>
    </HomePageLayout>
  )
}


